@if (signalConfigurationLoaded()) {
  <div
    id="app"
    class="app"
    [dir]="settings.rtl ? 'rtl' : 'ltr'"
    [ngClass]="signalThemeName()"
    [class.fixed-header]="settings.fixedHeader"
    [class.fixed-sidenav]="settings.fixedSidenav"
    [class.fixed-footer]="settings.fixedFooter"
    [class.horizontal-menu]="settings.menu == 'horizontal'"
    [class.compact]="settings.menuType == 'compact'"
    [class.mini]="settings.menuType == 'mini'"
  >
    <router-outlet></router-outlet>
  </div>
} @else {
  <div style="display: flex; align-items: center; justify-content: center; height: 100vh; font-family: sans-serif">
    Loading configuration...
  </div>
}
